import { http } from '@shared/api';

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export const accountApi = {
  // §14.2 — change password while logged in.
  changePassword: (body: ChangePasswordRequest) =>
    http.post('account/password/change', { json: body }).json<void>(),
};
